function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import Auth from "../../functions/authenticate";
import { Loader } from "../../components/loaders";
import { PageHeader, Card, Search, Filters, Pill, Empty, PlunkDropDown, AreaChart } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { rangeLabel } from "../../functions/range-label";
import { NotEnabled, OrpMenu, OrpStatus, orpMailboxSummary, orpDayRange, orpDateIn, orpPlural, orpWindowPhrase, orpWaitText, orpPlaceholders, orpPreview, orpPrettyMerge, ORP_WARM_DAYS, ORP_FIRST_SEND_DAY, orpTracked, trackingText } from "./common";
import Lifecycle from "./lifecycle";
import { api, audienceApi, normalizeLists, qs, errText, isNotEnabled, idStr, num, who, rate, rangeToApi, mailboxTone, leadLabel, leadTone, LEAD_STATUSES, parseMaybe, dateOnly, dateTime, ago } from "./api";

/** Timeline kinds in plain words. An "opened" may be an automatic open (Apple Mail, company filters). */
const TL_WORD = {
  sent: "sent",
  reply: "reply",
  bounce: "bounced",
  failed: "failed",
  open: "opened",
  click: "clicked"
};

/*
 * One outreach campaign (2026-10-09 redesign, mockup Campaign.dc.html; same layout family as the Journey page).
 * Top bar (back, name + status, Replies / Edit / ···), a status card that leads with what to do next and carries
 * the lifecycle buttons (nextTransitions; Start keeps its warming guard and confirm), four totals from the program's
 * all-time stats (GET programs/{id}), the sequence with what is left to fill in per email, and a side column:
 * how it sends (window + POST estimate pace), lead counts, the full lead table behind "See all leads", and the
 * mailboxes in one line. Sends per day (GET stats?range=, the global range) shows once something has been sent;
 * the timeline (GET timeline) sits under the sequence.
 *
 * Not shown: a per-step funnel and the A/B split. The stats API aggregates by program, day and mailbox only.
 */

const PAGE = 50;
class OutreachDetailComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "load", async () => {
      try {
        const d = await api("GET", this.path);
        if (!this._alive) return;
        this.setState({
          d,
          error: null
        });
        this.loadStats();
        this.loadLeads(this.state.skip);
        this.loadTimeline();
        this.loadEstimate();
      } catch (e) {
        if (!this._alive) return;
        if (isNotEnabled(e)) this.setState({
          notEnabled: true
        });else this.setState({
          error: errText(e, "The program could not be loaded.")
        });
      }
    });
    _defineProperty(this, "loadStats", async () => {
      try {
        const s = await api("GET", `${this.path}/stats${qs({
          range: rangeToApi(this.state.range)
        })}`);
        if (this._alive) this.setState({
          stats: s,
          statsErr: null
        });
      } catch (e) {
        if (this._alive) this.setState({
          statsErr: errText(e, "Stats are unavailable.")
        });
      }
    });
    _defineProperty(this, "loadTimeline", async () => {
      try {
        const t = await api("GET", `${this.path}/timeline${qs({
          $top: 100
        })}`);
        if (this._alive) this.setState({
          timeline: Array.isArray(t) ? t : []
        });
      } catch (e) {
        if (this._alive) this.setState({
          timeline: []
        });
      }
    });
    _defineProperty(this, "loadLeads", async (skip = 0) => {
      const {
        leadStatus,
        q
      } = this.state;
      try {
        const r = await api("GET", `${this.path}/leads${qs({
          status: leadStatus,
          q: q.trim(),
          $top: PAGE,
          $skip: skip
        })}`);
        if (this._alive) this.setState({
          leads: r,
          skip
        });
      } catch (e) {
        if (this._alive) this.setState({
          leads: {
            items: [],
            total: 0,
            err: errText(e)
          }
        });
      }
    });
    /** POST programs/{id}/estimate: a read-only computation (pace today, full pace, runway). */
    _defineProperty(this, "loadEstimate", async () => {
      try {
        const e = await api("POST", `${this.path}/estimate`, {});
        if (this._alive) this.setState({
          estimate: e
        });
      } catch (e) {
        if (this._alive) this.setState({
          estimate: null
        });
      }
    });
    _defineProperty(this, "remove", async () => {
      this.setState({
        deleting: true,
        deleteErr: null
      });
      try {
        await api("DELETE", this.path);
        const back = "/Email/outreach";
        this.props.history.push(back);
      } catch (e) {
        if (this._alive) this.setState({
          deleting: false,
          confirmDelete: false,
          deleteErr: errText(e, "The outreach campaign could not be deleted.")
        });
      }
    });
    _defineProperty(this, "onSearch", v => {
      this.setState({
        q: v
      });
      clearTimeout(this._qt);
      this._qt = setTimeout(() => this.loadLeads(0), 350);
    });
    _defineProperty(this, "refresh", () => {
      this.load();
    });
    this.state = {
      confirmDelete: false,
      deleting: false,
      deleteErr: null,
      d: null,
      stats: null,
      timeline: null,
      leads: null,
      leadStatus: "all",
      q: "",
      skip: 0,
      range: getGlobalRange(),
      error: null,
      notEnabled: false,
      statsErr: null,
      estimate: null,
      lists: null,
      showLeads: false,
      showMailboxes: false,
      cancelOpen: false
    };
    this._alive = true;
  }
  get id() {
    return decodeURIComponent(this.props.params && this.props.params.id || "");
  }
  get path() {
    return `/programs/${encodeURIComponent(this.id)}`;
  }
  async componentDidMount() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    this._tok = subscribePeriod(({
      range
    }) => {
      if (range && range !== this.state.range) this.setState({
        range
      }, this.loadStats);
    });
    this.load();
    audienceApi("GET", "").then(d => this._alive && this.setState({
      lists: normalizeLists(d)
    })).catch(() => this._alive && this.setState({
      lists: []
    }));
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
    clearTimeout(this._qt);
  }
  // ---------------------------------------------------------------- status card

  statusCard(p, d, m, est, steps) {
    const next = d.nextTransitions || [];
    const mbs = d.mailboxes || [];
    const mbsWarming = mbs.filter(x => x.status !== "active").length;
    // unchanged guard: Start stays disabled while any chosen mailbox is not active
    const blocked = p.status === "Approved" && mbsWarming ? {
      Running: `${num(mbsWarming)} of ${num(mbs.length)} chosen mailboxes are still warming.`
    } : null;
    const lifecycle = /*#__PURE__*/React.createElement(Lifecycle, {
      program: p,
      next: next.filter(t => t !== "Canceled"),
      blocked: blocked,
      hideBlockedText: true,
      onDone: this.refresh
    });
    const capNow = est ? Number(est.dailyCapacityNow) || 0 : m.capNow;
    const capFull = est ? Number(est.dailyCapacityAtFullRamp) || 0 : m.capFull;
    const when = orpWindowPhrase(d.window);
    const toFill = steps.filter(st => st.kind === "email").reduce((a, st) => a + orpPlaceholders(st).length, 0);
    let title,
      text,
      tone = "";
    const pausedNote = m.paused ? ` ${orpPlural(m.paused, "mailbox is", "mailboxes are")} paused and send nothing until resumed.` : "";
    switch (p.status) {
      case "Draft":
        if (p.reviewStatus === "Rejected") {
          title = "Sent back for changes";
          tone = "warn";
          text = `${p.reviewedBy ? `${who(p.reviewedBy, "An Administrator")} said: ` : ""}${p.rejectReason || "no reason given"}. Make the changes in Edit, then send it for approval again.`;
        } else {
          title = "Finish setting it up";
          text = toFill ? `${orpPlural(toFill, "part")} of the emails still ${toFill === 1 ? "needs" : "need"} filling in. When everything reads right, send it for approval.` : "When the emails, leads and mailboxes look right, send it for approval. Nothing is sent before it is approved and started.";
        }
        break;
      case "InReview":
        title = "Waiting for approval";
        text = "An Administrator checks the emails and the lead list before anything is sent. Once approved, you can start sending.";
        break;
      case "Approved":
        if (!m.total) {
          title = "Choose mailboxes to send from";
          tone = "warn";
          text = "This campaign has no mailboxes yet. Pick them in Edit.";
        } else if (mbsWarming) {
          title = "Ready when your mailboxes are";
          text = m.warming ? `${m.warming === m.total ? `All ${orpPlural(m.total, "mailbox is", "mailboxes are")}` : `${num(m.warming)} of ${orpPlural(m.total, "mailbox", "mailboxes")} are`} on ${orpDayRange(m.minWarm, m.maxWarm)} of warming up. Outreach emails can start once they reach day ${ORP_FIRST_SEND_DAY}, around ${orpDateIn(m.daysToFirstSend)}, and Start sending unlocks then. They build to full pace, about ${num(capFull)} a day, by around ${orpDateIn(m.daysToFullPace)}.${pausedNote}` : `Start sending unlocks once every mailbox on this campaign is active.${pausedNote}`;
        } else {
          title = "Ready to start";
          text = `${orpPlural(m.total, "mailbox", "mailboxes")} can send about ${num(capNow)} emails a day right now${capFull > capNow ? `, building to ${num(capFull)} as they finish warming up` : ""}. Emails go out ${when}, and follow-ups stop for anyone who replies.`;
        }
        break;
      case "Running":
        title = `Sending · ${num(m.sentToday)} of ${num(capNow)} today`;
        tone = "ok";
        text = `Emails go out ${when} from ${orpPlural(m.total, "mailbox", "mailboxes")}.${est && est.projectedCompletion ? ` At this pace the last emails go out around ${dateOnly(est.projectedCompletion)}.` : ""}${capFull > capNow ? ` The pace grows to about ${num(capFull)} a day as the mailboxes finish warming up.` : ""}${pausedNote}`;
        if (m.paused) tone = "warn";
        break;
      case "Paused":
        title = "Paused";
        tone = "warn";
        text = "No emails go out while it is paused. Resume to pick up where it left off.";
        break;
      case "Completed":
        title = "Finished";
        text = `Every lead has been through the sequence${p.completedDate ? ` (finished ${dateOnly(p.completedDate)})` : ""}. Replies still arrive in Replies.`;
        break;
      case "Canceled":
        title = "Canceled";
        tone = "warn";
        text = p.rejectReason ? `Canceled: ${p.rejectReason}. Nothing more is sent.` : "Nothing more is sent from this campaign.";
        break;
      default:
        title = p.status || "Outreach";
        text = "";
    }
    return /*#__PURE__*/React.createElement("div", {
      className: `orp-status-card ${tone}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-status-text"
    }, /*#__PURE__*/React.createElement("b", null, title), text ? /*#__PURE__*/React.createElement("span", null, text) : null, p.status === "Approved" && mbsWarming && m.warming ? /*#__PURE__*/React.createElement("div", {
      className: "orp-progress wide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-bar"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: `${Math.max(3, Math.min(100, Math.round(m.minWarm / ORP_WARM_DAYS * 100)))}%`
      }
    })), /*#__PURE__*/React.createElement("span", null, "Day ", num(Math.min(m.minWarm, ORP_WARM_DAYS)), " of ", ORP_WARM_DAYS, " of warming up")) : null), /*#__PURE__*/React.createElement("div", {
      className: "orp-status-actions"
    }, p.status === "Draft" ? /*#__PURE__*/React.createElement(Button, {
      themeColor: next.indexOf("InReview") > -1 ? "base" : "primary",
      onClick: () => this.props.history.push(`/Email/campaigns/outreach/${encodeURIComponent(p.id)}/edit`)
    }, "Open the editor") : null, lifecycle));
  }

  // ---------------------------------------------------------------- sequence

  sequence(steps, stopRules) {
    const emails = steps.filter(st => st.kind === "email");
    const days = steps.filter(st => st.kind === "wait").reduce((a, st) => a + (Number(st.waitDays) || 0), 0);
    let dayN = 0;
    let n = 0;
    return /*#__PURE__*/React.createElement("section", {
      className: "orp-panel orp-seq"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-panel-head"
    }, /*#__PURE__*/React.createElement("b", null, "The sequence"), /*#__PURE__*/React.createElement("span", null, emails.length ? `${orpPlural(emails.length, "email")}${days ? ` over ${orpPlural(days, "day")}` : ""}` : "No emails yet", stopRules && stopRules.onReply === false ? "" : " · stops for anyone who replies")), !steps.length ? /*#__PURE__*/React.createElement("div", {
      className: "orp-muted"
    }, "No steps yet. Write the emails in Edit.") : steps.map(st => {
      if (st.kind === "wait") {
        dayN += Number(st.waitDays) || 0;
        return /*#__PURE__*/React.createElement("div", {
          key: idStr(st.id),
          className: "orp-wait"
        }, orpWaitText(st));
      }
      if (st.kind !== "email") return null;
      n += 1;
      const left = orpPlaceholders(st).length;
      const vs = parseMaybe(st.variantsJson) || [];
      const preview = orpPreview(st);
      return /*#__PURE__*/React.createElement("div", {
        key: idStr(st.id),
        className: "orp-email"
      }, /*#__PURE__*/React.createElement("span", {
        className: "orp-day"
      }, "Day ", num(dayN)), /*#__PURE__*/React.createElement("div", {
        className: "orp-email-main"
      }, /*#__PURE__*/React.createElement("b", null, st.subject ? orpPrettyMerge(st.subject) : n === 1 ? "No subject yet" : "Same thread", vs.length ? /*#__PURE__*/React.createElement("span", {
        className: "orp-ab"
      }, "A/B ", vs.map(v => v.key).join("/")) : null), /*#__PURE__*/React.createElement("span", null, preview || "No text yet")), left ? /*#__PURE__*/React.createElement("span", {
        className: "orp-fill"
      }, orpPlural(left, "part"), " to fill in") : /*#__PURE__*/React.createElement("span", {
        className: "orp-ready"
      }, "\u2713 Ready"));
    }));
  }
  leadsTable(mbAddr) {
    const {
      leads,
      leadStatus,
      q,
      skip
    } = this.state;
    const statusOpts = [["all", "Status: all"]].concat(LEAD_STATUSES.map(x => [x, leadLabel(x)]));
    return /*#__PURE__*/React.createElement(Card, {
      span: 12,
      title: "All leads",
      hint: leads ? `${num(leads.total)} matching` : "",
      right: /*#__PURE__*/React.createElement(Filters, null, /*#__PURE__*/React.createElement(PlunkDropDown, {
        options: statusOpts,
        value: leadStatus,
        onChange: v => this.setState({
          leadStatus: v
        }, () => this.loadLeads(0)),
        width: "170px"
      }), /*#__PURE__*/React.createElement(Search, {
        value: q,
        onChange: this.onSearch,
        placeholder: "Search email"
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "wa-chip",
        onClick: () => this.setState({
          showLeads: false
        })
      }, "Hide"))
    }, leads && leads.err ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, leads.err) : null, !leads ? /*#__PURE__*/React.createElement("div", {
      className: "mini"
    }, "Loading\u2026") : !(leads.items || []).length ? /*#__PURE__*/React.createElement(Empty, null, "No leads match.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table ec-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Lead"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Step"), /*#__PURE__*/React.createElement("th", null, "Opened / clicked"), /*#__PURE__*/React.createElement("th", null, "Next send"), /*#__PURE__*/React.createElement("th", null, "Mailbox"), /*#__PURE__*/React.createElement("th", null, "Verified"))), /*#__PURE__*/React.createElement("tbody", null, leads.items.map(l => {
      const mj = parseMaybe(l.mergeJson) || {};
      return /*#__PURE__*/React.createElement("tr", {
        key: idStr(l.id)
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, l.email), /*#__PURE__*/React.createElement("span", {
        className: "code"
      }, [mj.first_name, mj.last_name].filter(Boolean).join(" "), mj.company ? ` · ${mj.company}` : "", mj.territory ? ` · ${mj.territory}` : "")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Pill, {
        tone: leadTone(l.status)
      }, leadLabel(l.status)), l.stoppedReason ? /*#__PURE__*/React.createElement("span", {
        className: "ec-status-extra"
      }, l.stoppedReason) : null), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(l.currentStep)), /*#__PURE__*/React.createElement("td", {
        className: "dim"
      }, l.openedDate || l.clickedDate ? /*#__PURE__*/React.createElement("span", {
        className: "orp-eng"
      }, l.openedDate ? /*#__PURE__*/React.createElement("span", {
        title: dateTime(l.openedDate)
      }, "Opened ", ago(l.openedDate)) : null, l.clickedDate ? /*#__PURE__*/React.createElement("span", {
        title: dateTime(l.clickedDate)
      }, "Clicked ", ago(l.clickedDate)) : null) : "-"), /*#__PURE__*/React.createElement("td", {
        className: "dim"
      }, l.nextSendAt ? dateTime(l.nextSendAt) : "-"), /*#__PURE__*/React.createElement("td", {
        className: "dim"
      }, l.mailboxId ? mbAddr(l.mailboxId) : "-"), /*#__PURE__*/React.createElement("td", {
        className: "dim"
      }, l.verifyStatus || "unverified"));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar",
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "mini"
    }, num(skip + 1), " to ", num(skip + leads.items.length), " of ", num(leads.total)), skip > 0 ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.loadLeads(Math.max(0, skip - PAGE))
    }, "Previous") : null, skip + leads.items.length < leads.total ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.loadLeads(skip + PAGE)
    }, "Next") : null)));
  }
  render() {
    if (!hasTenantFeature("outreach") || this.state.notEnabled) return /*#__PURE__*/React.createElement(NotEnabled, null);
    const {
      d,
      stats,
      statsErr,
      timeline,
      range,
      error,
      estimate,
      lists,
      showLeads,
      showMailboxes,
      cancelOpen
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view ec-view or-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Email/outreach"
      }, "Email"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: "/Email/outreach"
      }, "Outreach")),
      title: "Outreach campaign"
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, error));
    if (!d) return /*#__PURE__*/React.createElement(Loader, null);
    const p = d.program || {};
    const c = d.leads || {};
    const all = d.stats || {};
    const s = stats || {};
    const mbs = d.mailboxes || [];
    const m = orpMailboxSummary(mbs);
    const domains = new Set(mbs.filter(x => x.status !== "disabled").map(x => idStr(x.domainId))).size;
    const mbAddr = id => {
      const x = mbs.find(y => idStr(y.id) === idStr(id));
      return x ? x.address : `mailbox ${idStr(id)}`;
    };
    const days = (s.days || []).map(r => ({
      date: String(r.date).slice(0, 10) + "T12:00:00",
      value: Number(r.sent) || 0,
      marker: Number(r.replies) || 0
    }));
    const steps = d.steps || [];
    const settings = d.settings || {};
    const tracked = orpTracked(settings);
    const aud = p.audienceId != null && lists ? lists.find(l => l.id === idStr(p.audienceId)) : null;
    const editable = p.status !== "Completed" && p.status !== "Canceled";
    const next = d.nextTransitions || [];
    const pauseAt = settings.pauseBounceRate != null ? Number(settings.pauseBounceRate) : 0.03;
    const contacted = (Number(c.inSequence) || 0) + (Number(c.replied) || 0) + (Number(c.interested) || 0) + (Number(c.notInterested) || 0) + (Number(c.ooo) || 0) + (Number(c.completed) || 0) + (Number(c.bounced) || 0) + (Number(c.unsubscribed) || 0);
    const sentAll = Number(all.sent) || 0;
    const ver = settings.verification || {};
    const attested = !!(ver.attested && ver.date && Date.now() - new Date(ver.date).getTime() < 90 * 86400000);
    const approval = p.status === "InReview" ? "waiting for approval" : p.status === "Draft" ? p.reviewStatus === "Rejected" ? `sent back${p.reviewedBy ? ` by ${who(p.reviewedBy, "an Administrator")}` : ""}` : "not sent for approval yet" : p.reviewedBy ? `approved by ${who(p.reviewedBy, "an Administrator")}` : p.startedDate ? `started ${dateOnly(p.startedDate)}` : null;
    const capNow = estimate ? Number(estimate.dailyCapacityNow) || 0 : m.capNow;
    const capFull = estimate ? Number(estimate.dailyCapacityAtFullRamp) || 0 : m.capFull;
    const menu = [];
    menu.push({
      label: "Refresh numbers",
      run: this.refresh
    });
    if (next.indexOf("Canceled") > -1) menu.push({
      label: "Cancel program",
      danger: true,
      run: () => this.setState({
        cancelOpen: true
      })
    });
    if (p.status === "Draft" || p.status === "Canceled") menu.push({
      label: "Delete",
      danger: true,
      run: () => this.setState({
        confirmDelete: true
      })
    });
    const leadRows = [["Waiting for their first email", c.queued, true], ["In the sequence", (Number(c.inSequence) || 0) + (Number(c.ooo) || 0), true], ["Replied", (Number(c.replied) || 0) + (Number(c.interested) || 0) + (Number(c.notInterested) || 0), true], ["Finished without a reply", c.completed, true], ["Stopped (bounced, opted out or removed)", (Number(c.stopped) || 0) + (Number(c.bounced) || 0) + (Number(c.unsubscribed) || 0) + (Number(c.refused) || 0), false]].filter(([, v, always]) => always || Number(v) > 0);
    const mbLine = !m.total ? "None chosen yet" : m.paused ? `${num(m.total)} on this campaign · ${num(m.paused)} paused` : m.warming ? `${num(m.total)} on this campaign · ${m.warming === m.total ? "all" : num(m.warming)} warming up, ${orpDayRange(m.minWarm, m.maxWarm)}` : `${num(m.total)} on this campaign · all active`;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-view ec-view or-view orp-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-topbar"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Email/outreach",
      className: "orp-back",
      "aria-label": "Back to Outreach",
      title: "Back to Outreach"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15 18l-6-6 6-6"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "orp-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("h1", null, p.name || "Untitled outreach"), /*#__PURE__*/React.createElement(OrpStatus, {
      program: p
    })), /*#__PURE__*/React.createElement("span", {
      className: "sub"
    }, ["Outreach", `${num(c.total)} lead${Number(c.total) === 1 ? "" : "s"}`, approval].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement("span", {
      className: "orp-grow"
    }), /*#__PURE__*/React.createElement(Link, {
      className: "orp-btn",
      to: `/Email/outreach/replies?program=${encodeURIComponent(p.id)}`
    }, "Replies", Number(all.replies) ? ` · ${num(all.replies)}` : ""), editable && p.status !== "InReview" ? /*#__PURE__*/React.createElement(Link, {
      className: "orp-btn",
      to: `/Email/campaigns/outreach/${encodeURIComponent(p.id)}/edit`
    }, p.status === "Running" ? "Settings and leads" : "Edit") : null, /*#__PURE__*/React.createElement(OrpMenu, {
      items: menu,
      large: true,
      disabled: this.state.deleting
    })), /*#__PURE__*/React.createElement("div", {
      className: "orp-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-main"
    }, this.state.confirmDelete ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice warning ec-confirm",
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("span", null, "Delete this outreach campaign with its steps, leads and stats? This cannot be undone."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle danger",
      disabled: this.state.deleting,
      onClick: this.remove
    }, this.state.deleting ? "…" : "Yes, delete"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      disabled: this.state.deleting,
      onClick: () => this.setState({
        confirmDelete: false
      })
    }, "Keep")) : null, this.state.deleteErr ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, this.state.deleteErr) : null, cancelOpen && next.indexOf("Canceled") > -1 ? /*#__PURE__*/React.createElement("div", {
      className: "orp-cancel"
    }, /*#__PURE__*/React.createElement(Lifecycle, {
      program: p,
      next: next,
      only: ["Canceled"],
      initialConfirm: "Canceled",
      onDismiss: () => this.setState({
        cancelOpen: false
      }),
      onDone: () => {
        this.setState({
          cancelOpen: false
        });
        this.refresh();
      }
    })) : null, this.statusCard(p, d, m, estimate, steps), /*#__PURE__*/React.createElement("div", {
      className: "orp-tiles"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Leads"), /*#__PURE__*/React.createElement("b", null, num(c.total)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, !Number(c.total) ? "none loaded yet" : contacted ? `${num(contacted)} contacted so far` : "none contacted yet")), /*#__PURE__*/React.createElement("div", {
      className: "orp-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Sent"), /*#__PURE__*/React.createElement("b", null, num(sentAll)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, sentAll ? `${num(all.deliveredEst)} delivered` : p.status === "Running" ? "first emails go out in the sending hours" : "starts once you start")), /*#__PURE__*/React.createElement("div", {
      className: "orp-tile primary"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Replies"), /*#__PURE__*/React.createElement("b", null, num(all.replies)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, sentAll ? `${rate(all.replyRate)} · ` : "", num(all.interested), " interested")), /*#__PURE__*/React.createElement("div", {
      className: "orp-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Bounced"), /*#__PURE__*/React.createElement("b", null, num(all.bounced)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, sentAll ? `${rate(all.bounceRate)} · ` : "", "mailboxes pause themselves above ", +(pauseAt * 100).toFixed(1), "%"))), tracked.opens || tracked.clicks || Number(all.opens) || Number(all.clicks) ? /*#__PURE__*/React.createElement("div", {
      className: "orp-tiles orp-tiles-sub"
    }, tracked.opens || Number(all.opens) ? /*#__PURE__*/React.createElement("div", {
      className: "orp-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Opened"), /*#__PURE__*/React.createElement("b", null, num(all.opens)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, sentAll ? `${rate(all.openRate)} of sent · ` : "", "may include automatic opens")) : null, tracked.clicks || Number(all.clicks) ? /*#__PURE__*/React.createElement("div", {
      className: "orp-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Clicked"), /*#__PURE__*/React.createElement("b", null, num(all.clicks)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, sentAll ? `${rate(all.clickRate)} of sent` : "counts the first click per email")) : null) : null, this.sequence(steps, d.stopRules), sentAll ? /*#__PURE__*/React.createElement(React.Fragment, null, statsErr ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, statsErr) : null, /*#__PURE__*/React.createElement("section", {
      className: "orp-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-panel-head"
    }, /*#__PURE__*/React.createElement("b", null, "Sends per day"), /*#__PURE__*/React.createElement("span", null, rangeLabel(range), " \xB7 replies marked on the line")), days.length > 1 ? /*#__PURE__*/React.createElement(AreaChart, {
      rows: days,
      label: "sent",
      markerLabel: "replies"
    }) : /*#__PURE__*/React.createElement("div", {
      className: "orp-muted"
    }, stats && Number(s.sent) ? "Not enough days in this range for a chart." : "Nothing sent in this range."))) : null, /*#__PURE__*/React.createElement("section", {
      className: "orp-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-panel-head"
    }, /*#__PURE__*/React.createElement("b", null, "Latest activity"), /*#__PURE__*/React.createElement("span", null, "sends, bounces, replies", tracked.opens ? ", opens" : "", tracked.clicks ? " and clicks" : ""), /*#__PURE__*/React.createElement("span", {
      className: "orp-grow"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "orp-link",
      onClick: () => {
        this.loadTimeline();
        this.loadStats();
      }
    }, "Refresh")), timeline === null ? /*#__PURE__*/React.createElement("div", {
      className: "orp-muted"
    }, "Loading\u2026") : !timeline.length ? /*#__PURE__*/React.createElement("div", {
      className: "orp-muted"
    }, "Nothing has happened yet. Sends, bounces and replies show here once it is sending.") : /*#__PURE__*/React.createElement("ul", {
      className: "ec-timeline orp-timeline"
    }, timeline.map((t, i) => /*#__PURE__*/React.createElement("li", {
      key: i,
      className: "or-tl"
    }, /*#__PURE__*/React.createElement(Pill, {
      tone: t.kind === "reply" ? "success" : t.kind === "bounce" || t.kind === "failed" ? "danger" : t.kind === "click" || t.kind === "open" ? "info" : "neutral"
    }, TL_WORD[t.kind] || t.kind), /*#__PURE__*/React.createElement("span", {
      className: "dim",
      title: dateTime(t.at)
    }, ago(t.at)), /*#__PURE__*/React.createElement("span", null, t.email), t.stepOrdinal ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "step ", t.stepOrdinal) : null, t.mailboxId ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, mbAddr(t.mailboxId)) : null, t.detail ? /*#__PURE__*/React.createElement("span", {
      className: "or-snip"
    }, t.detail) : null, t.kind === "reply" ? /*#__PURE__*/React.createElement(Link, {
      to: `/Email/outreach/replies?program=${encodeURIComponent(p.id)}`
    }, "open in Replies") : null))))), /*#__PURE__*/React.createElement("aside", {
      className: "orp-side"
    }, /*#__PURE__*/React.createElement("section", {
      className: "orp-panel orp-kv"
    }, /*#__PURE__*/React.createElement("b", {
      className: "orp-h"
    }, "How it sends"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "From"), /*#__PURE__*/React.createElement("span", null, m.total ? `${orpPlural(m.total, "mailbox", "mailboxes")} on ${orpPlural(domains, "domain")}` : "No mailboxes yet")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "When"), /*#__PURE__*/React.createElement("span", {
      className: "cap"
    }, orpWindowPhrase(d.window))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Pace today"), /*#__PURE__*/React.createElement("span", null, num(m.sentToday), " of ", num(capNow), " a day", m.warming ? " (warming up)" : capFull > capNow ? ` (growing to ${num(capFull)})` : "")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Tracking"), /*#__PURE__*/React.createElement("span", null, tracked.clicks && tracked.opens ? "Replies, opens and link clicks" : tracked.clicks ? "Replies and link clicks, no open tracking" : tracked.opens ? "Replies and opens, no click tracking" : "Replies only, no open or click tracking"))), /*#__PURE__*/React.createElement("section", {
      className: "orp-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-panel-head"
    }, /*#__PURE__*/React.createElement("b", null, "Leads"), /*#__PURE__*/React.createElement("span", null, num(c.total), aud ? ` from ${aud.name}` : "")), /*#__PURE__*/React.createElement("div", {
      className: "orp-leadrows"
    }, leadRows.map(([l, v], i) => /*#__PURE__*/React.createElement("div", {
      key: l,
      className: i === 0 ? "first" : ""
    }, /*#__PURE__*/React.createElement("span", null, l), /*#__PURE__*/React.createElement("b", null, num(v))))), !attested && Number(c.total) ? /*#__PURE__*/React.createElement("div", {
      className: "orp-note"
    }, "Addresses not checked in the last 90 days: the first sends from each mailbox are watched for bounces.") : null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "orp-link",
      onClick: () => this.setState({
        showLeads: !showLeads
      }, () => {
        if (!this.state.showLeads) return;
        if (!this.state.leads) this.loadLeads(0);
      })
    }, showLeads ? "Hide the lead list" : "See all leads")), /*#__PURE__*/React.createElement("section", {
      className: "orp-panel orp-mbline"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-mbline-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-mbline-text"
    }, /*#__PURE__*/React.createElement("b", null, "Mailboxes"), /*#__PURE__*/React.createElement("span", null, mbLine)), /*#__PURE__*/React.createElement(Link, {
      to: "/Email/senders/outreach"
    }, "Manage")), mbs.length ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "orp-link",
      onClick: () => this.setState({
        showMailboxes: !showMailboxes
      })
    }, showMailboxes ? "Hide each mailbox" : "Show each mailbox") : null, showMailboxes ? /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table orp-mbtable"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Mailbox"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sent"), /*#__PURE__*/React.createElement("th", null, "Status"))), /*#__PURE__*/React.createElement("tbody", null, mbs.map(x => {
      const ms = (all.mailboxes || []).find(y => idStr(y.mailboxId) === idStr(x.id)) || {};
      return /*#__PURE__*/React.createElement("tr", {
        key: idStr(x.id)
      }, /*#__PURE__*/React.createElement("td", null, x.address), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(ms.sent)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Pill, {
        tone: mailboxTone(x.status)
      }, x.status), x.status === "warming" ? /*#__PURE__*/React.createElement("span", {
        className: "ec-status-extra"
      }, "day ", num(x.warmDay)) : x.pausedReason ? /*#__PURE__*/React.createElement("span", {
        className: "ec-status-extra"
      }, x.pausedReason) : null));
    }))) : null))), showLeads ? /*#__PURE__*/React.createElement("div", {
      className: "orp-leads wa-grid"
    }, this.leadsTable(mbAddr)) : null);
  }
}
export default withRouter(OutreachDetailComponent);